// Discount notification: shows the message for the shopper's discount code
// (discount_code cookie) or the active automatic discount. Promotions come
// from sections/osft-discount-notification.liquid (#OsftPromotions).
(() => {
  const dataElement = document.getElementById('OsftPromotions');
  if (!dataElement) return;

  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  // Store time zone offset, "-0600" → "-06:00"
  const offset = (data.timezoneOffset || '+0000').replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
  const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;

  // "2026-07-31" → the start or end of that day in the store's time zone
  const parseDate = (value, endOfDay) => {
    if (!value || !datePattern.test(value)) return null;
    const time = endOfDay ? 'T23:59:59.999' : 'T00:00:00';
    const date = new Date(`${value}${time}${offset}`);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const isCurrent = (promotion, now) => {
    const start = parseDate(promotion.start, false);
    const end = parseDate(promotion.end, true);
    if (promotion.start && !start) return false;
    if (promotion.end && !end) return false;
    return (!start || now >= start) && (!end || now <= end);
  };

  // "2026-07-31" → "Jul 31" (the calendar date as entered, in the page's language)
  const formatDate = (value) => {
    const match = datePattern.exec(value || '');
    if (!match) return value || '';
    const date = new Date(Date.UTC(+match[1], +match[2] - 1, +match[3]));
    return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    }).format(date);
  };

  const readCookie = (name) => {
    const match = document.cookie.split('; ').find((part) => part.startsWith(`${name}=`));
    if (!match) return '';
    try {
      return decodeURIComponent(match.slice(name.length + 1)).trim();
    } catch (error) {
      return '';
    }
  };

  const choose = () => {
    const now = new Date();
    const promotions = Array.isArray(data.promotions) ? data.promotions : [];
    const code = readCookie('discount_code');

    if (code) {
      const promotion = promotions.find(
        (item) => item.type === 'code' && item.code && item.code.toLowerCase() === code.toLowerCase()
      );
      if (promotion) {
        // A known code outside its dates won't work at checkout, so say nothing
        return isCurrent(promotion, now) ? { ...promotion, code: promotion.code || code } : null;
      }
      if (data.fallback) return { id: `code-${code.toLowerCase()}`, code, message: data.fallback };
    }

    return promotions.find((item) => item.type === 'automatic' && isCurrent(item, now)) || null;
  };

  // Fill a message element: placeholders become text, {code} gets its own badge
  const render = (element, promotion) => {
    const values = {
      percent: promotion.percent ?? '',
      start_date: formatDate(promotion.start),
      end_date: formatDate(promotion.end),
      title: promotion.title || '',
    };
    const parts = (promotion.message || '').split(/(\{\s*code\s*\})/);
    element.replaceChildren(
      ...parts.map((part) => {
        if (/^\{\s*code\s*\}$/.test(part)) {
          const badge = document.createElement('span');
          badge.className = 'osft-discount__code';
          badge.textContent = promotion.code || '';
          return badge;
        }
        return document.createTextNode(
          part.replace(/\{\s*(percent|start_date|end_date|title)\s*\}/g, (match, key) => values[key])
        );
      })
    );
  };

  const storageKey = (promotion) => `osft-discount-dismissed:${promotion.id}`;

  const isDismissed = (promotion) => {
    try {
      return window.sessionStorage.getItem(storageKey(promotion)) === '1';
    } catch (error) {
      return false;
    }
  };

  const dismiss = (promotion) => {
    try {
      window.sessionStorage.setItem(storageKey(promotion), '1');
    } catch (error) {
      // Storage unavailable: it stays closed on this page only
    }
    document.querySelectorAll('[data-osft-discount]').forEach((element) => (element.hidden = true));
  };

  const show = () => {
    const promotion = choose();
    const targets = document.querySelectorAll('[data-osft-discount]');
    if (!promotion || !promotion.message || isDismissed(promotion)) {
      targets.forEach((element) => (element.hidden = true));
      return;
    }
    targets.forEach((element) => {
      render(element.querySelector('[data-osft-discount-message]'), promotion);
      const close = element.querySelector('[data-osft-discount-close]');
      if (close) close.onclick = () => dismiss(promotion);
      element.hidden = false;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', show);
  } else {
    show();
  }
})();
